/**
 * Wraps react-apexcharts and ensures options.yaxis has at least as many valid
 * entries as there are series. Prevents ApexCharts "reading 'logarithmic' of undefined"
 * when the library accesses config.yaxis[index] for index >= our array length.
 */
import React from "react";
import Chart from "react-apexcharts";

const defaultYAxisEntry = { logarithmic: false, show: false };

function ensureYAxisArray(yaxis, minLength) {
  const arr = Array.isArray(yaxis) ? yaxis : yaxis != null ? [yaxis] : [];
  const base = arr[0] && typeof arr[0] === "object"
    ? { ...defaultYAxisEntry, ...arr[0], logarithmic: Boolean(arr[0].logarithmic) }
    : defaultYAxisEntry;
  const result = [];
  for (let i = 0; i < minLength; i++) {
    result.push(
      arr[i] && typeof arr[i] === "object"
        ? { ...defaultYAxisEntry, ...arr[i], logarithmic: Boolean(arr[i].logarithmic) }
        : { ...base, show: i > 0 ? false : base.show }
    );
  }
  return result;
}

export default function ApexChartSafe({ options = {}, series = [], ...rest }) {
  const seriesCount = Math.max(Array.isArray(series) ? series.length : 0, 1);
  const safeOptions = {
    ...options,
    yaxis: ensureYAxisArray(options.yaxis, seriesCount),
  };
  return <Chart options={safeOptions} series={series} {...rest} />;
}
